module.exports = __webpack_public_path__ + "img/boshqarCom.274a60ab.svg";